<template>
    <pm-simple-component-layout :toolbar-back="toolbarBack">
        <template slot="title">
            Privacy Policy
        </template>
        <pm-privacy-content />
    </pm-simple-component-layout>
</template>

<script>
import PmSimpleComponentLayout from "@/components/core/pm-simple-component-layout";
import PmPrivacyContent from "./privacy-content";
export default {
    name: "PrivacyPolicy",

    components: {
        PmSimpleComponentLayout,
        PmPrivacyContent,
    },

    data: () => {
        return ({
            prevRoute: '/',
        });
    },

    computed: {
        isIOS() {
            return !!navigator.platform && /iPad|iPhone|iPod|MacIntel/.test(navigator.platform);
        },
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },

    methods: {
        toolbarBack() {
            this.$router.push(this.prevRoute);
        },
    }
};
</script>
